// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3W8lT","newExpiryDate":"styles_newExpiryDate__3fErv","footer":"styles_footer__3t1Fc"};